module.exports = __webpack_public_path__ + "img/minus.eaa47afa.svg";